(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alma-mobile-polish"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileMedia = window.matchMedia('(max-width: 989px) and (hover: none)');
    const observedCards = new WeakSet();

    const prepareCards = (root = document) => {
      if (!mobileMedia.matches || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const card = entry.target;

            if (!entry.isIntersecting) {
              card.classList.remove('alma-mobile-secondary-image');
              return;
            }

            if (entry.intersectionRatio < 0.62 || card.dataset.almaPreviewed === 'true') return;

            card.dataset.almaPreviewed = 'true';
            window.setTimeout(() => {
              if (!card.isConnected) return;
              card.classList.add('alma-mobile-secondary-image');

              window.setTimeout(() => {
                card.classList.remove('alma-mobile-secondary-image');
              }, 1250);
            }, 320);
          });
        },
        { threshold: [0, 0.62, 0.85] }
      );

      root.querySelectorAll('.product-card-wrapper').forEach((card) => {
        if (observedCards.has(card)) return;
        if (!card.querySelector('.media--hover-effect > img + img')) return;

        observedCards.add(card);
        observer.observe(card);
      });
    };

    const initialize = (root = document) => {
      prepareCards(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('header-drawer details').forEach((detailsElement) => {
    detailsElement.addEventListener('toggle', () => {
      if (!detailsElement.open) return;
      const submenu = detailsElement.querySelector(':scope > .menu-drawer__submenu .menu-drawer__inner-submenu');
      if (submenu) submenu.scrollTop = 0;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
